import React from 'react';

// enums
import { PAGE_POSITIONS } from '@/enums/TablePageLayout';

// Libraries
import { FormattedMessage } from 'react-intl';
import PageLayout, { PageLayoutProps } from './PageLayout';
import { Typography } from '@capintel/component-lib/typography';
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';

type Props = PageLayoutProps & {
  hasData?: boolean;
  detailsElement?: JSX.Element;
  isLoading?: boolean;
  loadingElement?: JSX.Element;
  noDataElement?: JSX.Element;
  pageActionsPosition?: PAGE_POSITIONS;
  searchInputPosition?: PAGE_POSITIONS;
  showSubHeader?: boolean;
  showTablePageContainer?: boolean;
  subPageTitle?: string;
  tableElement?: JSX.Element;
  tabsElement?: JSX.Element;
};

const TablePageLayout = ({
  pageActionsElement,
  pageActionsPosition = PAGE_POSITIONS.TOP_RIGHT_TABLE_CONTAINER,
  children,
  showSubHeader = true,
  hasData = false,
  detailsElement,
  isLoading = false,
  loadingElement,
  mainClassName,
  noDataElement,
  pageTitle,
  pillsFilterElement,
  searchInputElement,
  searchInputPosition = PAGE_POSITIONS.TOP_RIGHT_TABLE_CONTAINER,
  showHeader = true,
  showPage = true,
  showTablePageContainer = true,
  subPageTitle,
  tableElement,
  tabsElement,
}: Props) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  return (
    <PageLayout
      pageActionsElement={pageActionsPosition === PAGE_POSITIONS.TOP_RIGHT_PAGE ? pageActionsElement : undefined}
      mainClassName={mainClassName}
      pageTitle={pageTitle}
      pillsFilterElement={pillsFilterElement}
      searchInputElement={searchInputPosition === PAGE_POSITIONS.TOP_RIGHT_PAGE ? searchInputElement : undefined}
      showHeader={showHeader}
      showPage={showPage}
    >
      {showTablePageContainer && (
        <div className="table-page-container">
          {showSubHeader && (
            <div className="table-page-header" ref={headerRef}>
              {detailsElement}
              <div className="navigation-header">
                {subPageTitle && (
                  <div className="header-title navigation-header-item">
                    <Typography as={ALLOWED_HTML_TAGS.H2} variant="headerSm">
                      <FormattedMessage id={subPageTitle} />
                    </Typography>
                  </div>
                )}

                {searchInputPosition === PAGE_POSITIONS.TOP_RIGHT_TABLE_CONTAINER && <div className="navigation-header-item">{searchInputElement}</div>}
                {pageActionsPosition === PAGE_POSITIONS.TOP_RIGHT_TABLE_CONTAINER && (
                  <div className="page-actions-section navigation-header-item">{pageActionsElement}</div>
                )}
              </div>

              {tabsElement}
            </div>
          )}

          {isLoading && loadingElement}

          {!isLoading && !hasData && noDataElement}

          {hasData && (
            <div
              className={`table-page-container-table ${showSubHeader ? 'with-sub-header' : ''}`}
              style={{ maxHeight: `calc(100% - ${headerRef?.current?.offsetHeight || 0}px)` }}
            >
              {tableElement}
            </div>
          )}
        </div>
      )}
      {children}
    </PageLayout>
  );
};

export default TablePageLayout;
